import React from 'react';

/**
 * The cards for what Amazon SES reported after accepting each email. The
 * backend sends these counts only once it records SES outcomes.
 */
const DELIVERY_CARDS = [
	{
		key: 'delivered',
		testId: 'email-stat-delivered',
		label: 'Delivered',
		hint: 'Accepted by the receiving mail server',
		icon: 'bi-envelope-check',
		color: 'success',
	},
	{
		key: 'bounced',
		testId: 'email-stat-bounced',
		label: 'Bounced',
		hint: 'Refused by the receiving mail server',
		icon: 'bi-envelope-x',
		color: 'danger',
	},
	{
		key: 'complained',
		testId: 'email-stat-complained',
		label: 'Complained',
		hint: 'Marked as spam by the recipient',
		icon: 'bi-flag',
		color: 'dark',
	},
	{
		key: 'suppressed_recipients',
		testId: 'email-stat-suppressed',
		label: 'Not Receiving Email',
		hint: 'Users whose address SES blocks',
		icon: 'bi-slash-circle',
		color: 'secondary',
	},
];

/**
 * What Amazon SES reported after accepting the emails, shown on the page
 * above the filters; nothing until the statistics carry the delivered count.
 */
const DeliveryStatisticsCards = ({ stats }) => {
	if (stats?.delivered === undefined) {
		return null;
	}

	// The page styles its stat cards inside .email-statistics
	return (
		<div className="email-statistics">
			<div className="row g-3 mb-4">
				{DELIVERY_CARDS.map(({ key, testId, label, hint, icon, color }) => (
					<div className="col-md-3" key={key}>
						<div className="card stat-card" data-testid={testId}>
							<div className="card-body">
								<div className="d-flex justify-content-between align-items-start">
									<div>
										<p className="text-muted mb-1">{label}</p>
										<h3 className={`mb-0 text-${color}`}>
											{(stats[key] || 0).toLocaleString()}
										</h3>
										<small className="text-muted">{hint}</small>
									</div>
									<div className={`stat-icon bg-${color}`}>
										<i className={`bi ${icon}`} />
									</div>
								</div>
							</div>
						</div>
					</div>
				))}
			</div>
		</div>
	);
};

export default DeliveryStatisticsCards;
